<div class="panel-container">
    <div class="home-left-panel">
        <h2 class="content-block welcome">Welcome to the Allograft Pathology Smart Template Scoring System</h2>

        <div class="tileview-container">
            <dx-tile-view class="dx-tile-content tile-view">
                <dxi-item
                    *ngFor="let img of images"
                    width="1200"
                    height="1200"
                    baseItemHeight="200"
                    baseItemWidth="200"
                    [widthRatio]="img.widthRatio"
                    [heightRatio]="img.heightRatio">

                    <div class="image" [style.background-image]="'url(' + img.imgsrc + ')'"></div>

                </dxi-item>
            </dx-tile-view>

            <div class="content-block home-instructions" *ngIf="!isLoggedIn" >
                If you are a registered user of the Smart Template Scoring System, please click the login button to access the available worksheets.       
            </div>
    
            <div class="content-block home-instructions" *ngIf="isLoggedIn" >
                Click on one of the configured worksheets available in the left navigation panel to proceed.
            </div>
        </div>
          
    </div>

    <!--<div class="home-right-panel"></div>-->
</div>

